module.exports = __webpack_public_path__ + "img/vertical_6_1_7016.7ed2f1d7.png";